var App;
jQuery(document).ready(function ($) {
    
    
    var btn = $('#button');
    $(window).scroll(function() {
      if ($(window).scrollTop() > 300) {
        btn.addClass('show');
      } else {
        btn.removeClass('show');
      }
    });
  
    btn.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({scrollTop:0}, '300');
    });
  
  



    jQuery(".menu-trigger").click(function () {
        jQuery(this).next(".sub-menu").slideToggle("slow");
    });

    $('.grid').isotope({
        itemSelector: '.grid-item',
        percentPosition: true,
        masonry: {
            columnWidth: '.grid-sizer',
            gutter: '.gutter-sizer'
        }
    });

    var $win = $(window);

    App = {

        animateLazyLoad: function () {
            var a = $win.scrollTop(),
                n = $win.height();
            $(".u-lazy").each(function () {
                $(this).offset().top <= a + .95 * n && $(this).addClass("u-lazy--animate");
            });

            $(".img-in").each(function () {
                var el = jQuery(this);
                setTimeout(function () {
                    el.offset().top <= a + .95 * n && el.addClass("active");
                }, 500);
            });
        },

        slideswcardsBgresize: function () {
            jQuery('.c-slides-w-cards').each(function () {
                var val_top = 0;
                var val_bottom = 0;

                if (jQuery(this).find('.c-slider').length > 0) {
                    var val_top = val_top + jQuery(this).find('.c-slider').height() / 2;
                }

                if (jQuery(this).find('.c-cards__wrap-item').length > 0) {
                    var val_bottom = val_bottom + (jQuery(this).find('.c-cards__wrap-item').last().find('.c-card__wrap').height() - 50);
                }

                jQuery(this).find('.c-slides-w-cards__bg').css({ 'top': val_top, 'bottom': val_bottom });
            });
        },

        childPagesBg: function () {
            jQuery('.c-childpages').each(function () {
                var par = jQuery(this);
                var offsetheight = 0;
                par.find('.c-card').each(function () {
                    var height = jQuery(this).height() - jQuery(this).find('.c-card__img').innerHeight();
                    if (offsetheight < height) {
                        offsetheight = height;
                    }
                });
                jQuery(this).find('.c-childpages__wrap-bg').css({ 'bottom': offsetheight });
            });
        },

        resizeSubMenu: function () {
            jQuery('.c-header__nav-menu .sub-menu').each(function () {
                var el_width = jQuery(window).width() - jQuery(this).offset().left;
                jQuery(this).innerWidth(jQuery(window).width()).css({ 'left': -jQuery(this).parents('li').offset().left, 'padding-left': jQuery(this).parents('li').offset().left });
            });
        },

        bindUI: function () {},

        init: function () {
            App.bindUI();

            jQuery(document).on('click', '.c-header__toggle', function () {
                jQuery('.c-header').toggleClass('c-header--navopen');
                jQuery('html').toggleClass('site--navopen');
            });

            var $grid = jQuery('.c-posts__wrap--isotope').isotope({
                itemSelector: '.c-posts__item',
                layoutMode: 'fitRows'

            });

            jQuery(document).on('click', '.c-posts__nav a', function () {
                jQuery(this).parents('.c-posts__nav').find('.active').removeClass('active');
                jQuery(this).addClass('active');
                var cat = jQuery(this).data('term');
                $grid.isotope({ filter: cat });
                return false;
            });
        }
    };

    App.init();

    App.animateLazyLoad();
    App.slideswcardsBgresize();
    App.childPagesBg();

    $win.on('scroll', function () {
        App.animateLazyLoad();
    });

    $win.on('resize', function () {
        App.slideswcardsBgresize();
        App.childPagesBg();
        App.resizeSubMenu();
    });

    $win.on('load', function () {
        $('.u-load').addClass('u-load--loaded');
        App.slideswcardsBgresize();
        App.childPagesBg();
        App.animateLazyLoad();
        App.resizeSubMenu();
    });

    $(document).on('facetwp-loaded', function() {
        // on facetwp load, reload isotope items
        jQuery('.grid').isotope( 'reloadItems' ).isotope();
    });
});

function historyback(url) {
    if (window.history.length > 2) {
        // if history is not empty, go back:
        window.history.back();
    } else if (url) {
        // go to specified fallback url:
        window.location = url;
    }
}

/*
var appform = document.querySelector( '.c-appform .wpcf7' );

appform.addEventListener( 'wpcf7invalid', function( event ) {

      setTimeout( function() {
        jQuery('.c-appform__wrap').stop().animate({
          scrollTop: jQuery('.wpcf7-not-valid-tip').eq(0).parents('.c-form__group').position().top - 140,
        }, 500);
      }, 100);
    }, false
    
);

*/